module.exports = __webpack_public_path__ + "static/avanti-tower-4624957786fdc164ddef9c32dcb394b5.png";